import { Login } from "./login/Login";
import Chatbot from "./components/Chatbot";
import SsoCallback from "./login/SsoCallback";
import Layout from "./Layout";
import IRoute from "./IRoute";
import Logout from "./components/Logout";

export const HomePath = "/";
export const SSOCallbackPath = "/sso/callback";
export const ChatPath = "/chat";
export const LoginPath = "/login";
export const LogoutPath = "/logout";

const routes: IRoute[] = [
  {
    path: HomePath,
    element: Layout,
    // errorElement: ErrorPage,
    children: [
      {
        index: true,
        element: "login",
      },
      {
        path: SSOCallbackPath,
        element: SsoCallback,
      },
      {
        path: LoginPath,
        element: Login,
      },
      {
        path: ChatPath,
        isProtected: true,
        element: Chatbot,
      },
      {
        path: LogoutPath,
        isProtected: true,
        element: Logout,
      },
    ],
  },
];

export default routes;
